import React from 'react';
import Well from '$components/ProductDashboard/Well';
import styles from '../textStyles.scss';

const GreInstructions = () => (
  <Well>
    <div className={styles.layout}>
      <h2 className={styles.header}>So you&apos;re ready for a practice test?</h2>
      <div>
        Excellent. Sitting for a full-length mock exam is something all students should do
        at least once before taking the real deal. Doing so will not only put all that
        you&apos; learned to the test, but it will also give you the opportunity to
        strengthen your mental fortitude and concentrational endurance: two factors that
        are indispensable to a top-percentile performance. You can simulate the
        full-length test by stringing together some of the practice sets available above.
        Here are a few tips to help you approximate the actual conditions of the test as
        much as possible.
      </div>

      <ul>
        <li>
          <b>Set aside at least four hours.</b> The GRE is long - and you&apos; need at
          least that much time to take a full-length test (including breaks). Make sure
          that you&apos; in a quiet, comfortable spot with few distractions and a strong
          internet connection. Sitting for the test at the same time of day as your actual
          exam is also useful.
        </li>
        <li>
          <b>Follow the sequence of the exam.</b> Begin with the writing section: an Issue
          prompt followed by an Argument prompt. Then follow with five, alternating
          20-question problem sets. Just like the actual exam, one of these sets will be
          the unscored experimental section. Practicing with an additional set will give
          you a sense for how long the GRE really is.
        </li>
        <li>
          <b>Flip a coin.</b> This will determine which experimental section to give
          yourself. If it&apos; heads, give yourself an extra verbal section (i.e.,
          V/Q/V/Q/V); and if it&apos; tails, give yourself an extra quantitative section
          (i.e., Q/V/Q/V/Q).
        </li>
        <li>
          <b>Take your breaks.</b> Making effective use of the time between sections is
          essential for high performance. Give yourself one ten-minute break after the
          second 20-question problem set, and five one-minute breaks between all the other
          sections of the test. Use your longer break to have a snack (chocolate?) and go
          to the bathroom.
        </li>
        <li>
          <b>Warm up beforehand.</b> Coach wouldn&apos; send you into the game cold. So
          why would you warm up with the exam? Make sure that the first problems you do on
          test day aren&apos; the ones that count. A few practice problems and/or a
          five-minute free-write can help get the juices flowing.
        </li>
        <li>
          <b>Keep a positive mindset.</b> The GRE is hard enough. So don&apos; make the
          test any more difficult than it already is. That means adopting a commitment to
          be kind and supportive with yourself - no matter what happens. Assuming that you
          can find a solution to a tricky problem can often help you discover a path
          forward.
        </li>
        <li>
          <b>Stick to your training.</b> You&apos; worked for weeks (or months) to bring
          yourself to this point, and you&apos; seen your score improve over the
          intervening time. Since you know that your system works, it is not the time to
          improvise when the game is on the line. Stay frosty and remember your training.
        </li>
        <li>
          <b>Have fun!</b> At the end of the day, the GRE is just a series of puzzles -
          puzzles that you can successfully solve. The more that you can enjoy the
          process, the more confident and relaxed you&apos; be, allowing you to perform at
          your best.
        </li>
      </ul>
    </div>
  </Well>
);

export default GreInstructions;
